import { dataKeys, storageKeys } from '../constants/storage';
import { loginSuccessAction } from '../modules/auth/actions';
import { LOGIN_SUCCESS, LOGIN_TOKEN } from '../modules/auth/constants';
import { store } from '../modules/redux/sagas'

// Helper for UTF-8 safe base64 encoding
const b64EncodeUnicode = (str) => {
    if (!str) return '';
    try {
        return btoa(Array.from(new TextEncoder().encode(str), (b) => String.fromCharCode(b)).join(""));
    } catch (e) {
        return btoa(str); // Fallback
    }
};

// Helper for UTF-8 safe base64 decoding
const b64DecodeUnicode = (str) => {
    if (!str) return '';
    try {
        return new TextDecoder().decode(Uint8Array.from(atob(str), (c) => c.charCodeAt(0)));
    } catch (e) {
        return atob(str); // Fallback
    }
};

export const setString = (key, value) => {
    localStorage.setItem(key, b64EncodeUnicode(value))
}

export const setStringLocal = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value))
}

export const getString = key => {
    const data = localStorage.getItem(key);
    return data ? b64DecodeUnicode(data) : '';
}

export const setJson = (key, value) => {
    localStorage.setItem(key, b64EncodeUnicode(JSON.stringify(value)))
}

export const getJson = key => {
    const data = localStorage.getItem(key);
    if (!data) return null;
    try {
        return JSON.parse(b64DecodeUnicode(data));
    } catch (e) {
        console.error("Storage error:", e);
        return null;
    }
}

export const clearLocaleStorage = key => {
    localStorage.removeItem(key)
}
export const clearLocaleStorageAr = (keys=[]) => {
    if(keys.length > 0) {
        keys.map(key => {
            localStorage.removeItem(key)
            return key;
        })
    }
}
export const handleLogout = (keys=[]) => {
    if(keys.length > 0) {
        keys.map(key => {
            localStorage.removeItem(key)
            return key;
        })
    } else {
        localStorage.removeItem(storageKeys.TOKEN)
        localStorage.removeItem(storageKeys.USER)
        localStorage.removeItem(storageKeys.ROLE)
        localStorage.removeItem(dataKeys.PHOTO)
        localStorage.removeItem(storageKeys.BRANCH_SHOP)
        localStorage.removeItem(storageKeys.BRANCH_SHOP_PHOTO)
        localStorage.removeItem(storageKeys.CONFIRMATION_DATA)
        localStorage.removeItem(storageKeys.BOOKING_DATA)
    }
    store.dispatch({
        type: LOGIN_SUCCESS,
        payload: {
            user: null,
            token: null,
            roles: null
        }
    })
}

export const tokenSuccessAction = (token) => {
    const auth = store.getState().authReducer;
    const user = auth?.user;
    saveAuth(token, user)
}

const saveAuth = (newToken, member) => {
    store.dispatch(loginSuccessAction({ token: newToken, user: member, photo: member?.picUrl }));
    if (newToken) localStorage.setItem(storageKeys.TOKEN, btoa(newToken));
    if (member) localStorage.setItem(storageKeys.USER, JSON.stringify(member));
};